import { stringifyPageRange, makeRange } from './page-range';

/**
 * @param {pdfDocumentProxy} pdfFile
 * @return {string}
 */
const getSelectedPages = (pdfFile) => {
  if (pdfFile.deletions.length) {
    const selectedPages = pdfFile.selections.length ? pdfFile.selections : makeRange(1, pdfFile.file.pdfDocument.numPages);
    return stringifyPageRange(selectedPages.filter((page) => pdfFile.deletions.indexOf(page) < 0), ',');
  }

  return pdfFile.selections.length
    ? stringifyPageRange(pdfFile.selections, ',')
    : `1-${pdfFile.file.pdfDocument.numPages}`;
};

export default getSelectedPages;
